import cookies from 'react-cookies';

export const translated = element => (element ? element[cookies.load('localization') || 'ro'] : '');
